import { Box, Typography } from "@mui/material"
import SwipeCardStack from "../components/SwipeCardStack"
import photoData from "../assets/storyData.json";

const StorySection = () => {
  const cardsData = photoData
    // .slice(60, 70)
    // .filter((photo) => !photo.isVideo)
    .map((photo, index) => ({
      id: index,
      mediaUrl: (photo.isVideo ? '/web-video/' : '/web-images/') + photo.src,
      isVideo: photo.isVideo,
      description: photo.src,
      themeColor: "#ff69b4",
      ...photo,
    }))

  return (
    <Box sx={{
      zIndex: 1,
      position: "relative",
      p: 4,
      mt: 4,
      minHeight: "100dvh",
      scrollSnapAlign: 'start',
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <Typography
        align="center"
        variant="h4"
        color="secondary"
        sx={{ fontWeight: 'bold' }}
      >
        เรื่องราวของเรา 💖
      </Typography>

      <SwipeCardStack cardsData={cardsData} />
    </Box>
  )
}

export default StorySection